import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, Award } from 'lucide-react';
const brands = [{
  name: 'Mitsubishi Electric',
  tagline: 'Diamond Dealer, highest tier',
  body: 'Top tier installer accreditation. Fewer than 100 hold this status in Australia. The first brand we recommend for Perth conditions.',
  slug: '/brand/mitsubishi-air-conditioner-perth/',
  isDiamond: true
}, {
  name: 'Daikin',
  tagline: 'Authorised specialist',
  body: 'Global benchmark for reliability. Full residential and commercial range with full manufacturer warranty.',
  slug: '/brand/daikin-air-conditioning-perth/'
}, {
  name: 'Rinnai HRV',
  tagline: 'Authorised installer',
  body: 'Ducted reverse cycle with smart zoning. Strong value for whole home installs and replacements.',
  slug: '/brand/rinnai-air-conditioning-perth/'
}, {
  name: 'iZone',
  tagline: 'Smart home control',
  body: 'Control every zone, fan and grille from your phone. Australian made smart home tech that pairs with any ducted system we install.',
  slug: '/smart-zone/'
}];
export function Brands() {
  return <section id="brands" className="bg-white py-20 md:py-28 scroll-mt-24" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="max-w-3xl mb-14" data-id="element-44">
          <div className="text-xs font-semibold uppercase tracking-widest text-brand mb-4" data-id="element-45">
            Brands We Install
          </div>
          <h2 className="text-2xl md:text-4xl font-bold tracking-tight text-ink leading-tight" data-id="element-46">
            Four brands. One Diamond accredited installer.
          </h2>
          <p className="mt-5 text-lg text-stone-600 max-w-xl" data-id="element-47">
            We are brand neutral by design. We recommend what suits your home,
            budget and the way you live, not what pays us the most.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-48">
          {brands.map((brand, i) => <motion.a key={i} href={brand.slug} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className={`group relative flex flex-col rounded-2xl p-7 border transition-all hover:-translate-y-1 hover:shadow-xl ${brand.isDiamond ? 'bg-brand text-white border-brand' : 'bg-white border-stone-200 hover:border-brand/40 shadow-md'}`} data-id="element-49">
              <div className="h-14 mb-6 flex items-center" data-id="element-50">
                <div className={`text-2xl font-extrabold tracking-tight ${brand.isDiamond ? 'text-white' : 'text-ink'}`} data-id="element-51">
                  {brand.name}
                </div>
              </div>

              <div className={`text-[11px] uppercase tracking-widest font-semibold mb-3 flex items-center gap-1.5 ${brand.isDiamond ? 'text-accent' : 'text-brand'}`} data-id="element-52">
                {brand.isDiamond && <Award size={12} data-id="element-53" />}
                {brand.tagline}
              </div>

              <p className={`text-sm leading-relaxed mb-6 flex-grow ${brand.isDiamond ? 'text-white/80' : 'text-stone-600'}`} data-id="element-54">
                {brand.body}
              </p>

              <span className={`inline-flex items-center gap-1.5 text-sm font-semibold mt-auto group-hover:gap-2.5 transition-all ${brand.isDiamond ? 'text-white' : 'text-brand'}`} data-id="element-55">
                Learn more
                <ArrowUpRight size={14} data-id="element-56" />
              </span>
            </motion.a>)}
        </div>

        <div className="mt-10 p-6 bg-brand-50 rounded-2xl border border-brand/10 text-center" data-id="element-57">
          <p className="text-base text-ink" data-id="element-58">
            <strong data-id="element-59">Authority note:</strong> Mitsubishi Electric Diamond Dealer
            is the highest tier of Mitsubishi installer accreditation in
            Australia. Langler Air is tested on installation quality every year.
          </p>
        </div>
      </div>
    </section>;
}